import friendProfileResponse from '../components/FriendProfile/friendProfile.json';

// for friendStats

export function getFriendStats() {
  return friendProfileResponse.friendStats;
}

// for friend activity
export function getFriendActivity(timePeriod) {
  switch (timePeriod) {
    case 'thisWeek':
      return friendProfileResponse.friendActivity.thisWeek.activityData;
    case 'today':
      return friendProfileResponse.friendActivity.today.activityData;
    case 'thisMonth':
      return friendProfileResponse.friendActivity.thisMonth.activityData;
    case 'allTime':
      return friendProfileResponse.friendActivity.allTime.activityData;
    default:
      return friendProfileResponse.friendActivity.thisWeek.activityData;
  }
}

// for friend badges
export function getFriendBadgesService(skip, limit) {
  const badges = [];
  let i = 0;
  while (friendProfileResponse.friendBadges.badges[i] && i - skip < limit) {
    badges.push(friendProfileResponse.friendBadges.badges[i]);
    i++;
  }

  const response = {
    wonBadges: friendProfileResponse.friendBadges.wonBadges,
    maxBadges: friendProfileResponse.friendBadges.maxBadges,
    badges,
  };
  return response;
}

// for friend scorign history
export function getFriendScoringHistoryService(timePeriod) {
  const response = {
    totalWeek: friendProfileResponse.friendScoringHistory.totalWeek,
    scoringHistory:
      friendProfileResponse.friendScoringHistory.scoringHistory[timePeriod],
  };
  return response;
}

// for friend profile
export function getFriendProfileService() {
  return {
    private: friendProfileResponse.friendProfile.private,
    friend: friendProfileResponse.friendHeader.friend,
  };
}
// for friend header
export function getFriendHeaderService() {
  return friendProfileResponse.friendHeader;
}
